import React, { Component } from 'react'
import NeedHelp from '../Elements/NeedHelp';
import InputGroup from './inputGroup';
import { getInitialRoute } from '../../../../../../utils';
import CheckBoxField from '../Elements/CheckboxField';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import { Button } from 'react-bootstrap';

class Rss extends Component {
    state = {
        displayName: "",
        url: "",
        nameError: false,
        urlError: false,
        checkBox: false,
        sampleDownloadView: true,
        isLoading: false,
    }

    onTextChange = (e) =>this.setState({ [e.target.name]: e.target.value, nameError: false, urlError: false });

    onSubmit = () => {
        const { url, displayName, checkBox } = this.state
        const { navigation, hideAddfeed, wallId } = this.props
        this.setState({ isLoading: true });

        if (!displayName || displayName == "") this.setState({ nameError: true, isLoading: false })
        else this.setState({ nameError: false })
        if (!url || url == "") this.setState({ urlError: true, isLoading: false })
        else {
            this.setState({ urlError: false, nameError: false, isLoading: true });

            var obj = {
                wallId: wallId,
                networkId: 12,
                filter: 13,
                fieldtitle: displayName,
                moderation: checkBox ? 1 : 0
            }


            if (!url.includes("://")) {
                this.setState({ urlError: true, isLoading: false });
                return;
            } else {
                obj['field'] = url;
            }

            createFeedAction(obj, 12, (feedId) => this.setState({ isLoading: false }, () => {
                if (feedId) {
                    navigation(`/moderation/index/${wallId}`);
                    hideAddfeed();
                }
            }))
        }
    }

    render() {
        const { url, displayName, nameError, urlError, checkBox, isLoading } = this.state;
        const { toggleDownloadView } = this.props;

        return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-body create_feed_wt">
                            <div className="tab-content">
                                <div className="tab-pane fade active show" id="createPopUp13">
                                    <InputGroup title={'Display Name'} id='rssname' icon={'font'} value={displayName} setValue={this.onTextChange} error={nameError} name={'displayName'}/>
                                    <InputGroup title={'Feed Url'} id='rssfeed' icon={'link'} value={url} setValue={this.onTextChange} error={urlError} name={'url'}/>
                                    <span className="help-section d-flex justify-content-end">
                                        <Button variant='link' id="sample_xml" className="text-gradient" onClick={() => toggleDownloadView(true)}>Download Sample Format</Button>
                                    </span>
                                </div>
                                <div className="hideforBSearch">
                                    <div className="checkbox-inline">
                                        <CheckBoxField isChecked={checkBox} onChangeHandler={(e) => this.setState({ checkBox: e.target.checked })} name={"moderation"} id="checkbox_rss" />
                                    </div>
                                </div>
                            </div>
                            <div className="form-actions">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    {getInitialRoute() === 'widget' ?
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/704077620'} supportLink={'https://taggbox.com/support/how-to-embed-rss-feed-on-website/'} />
                                        :
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/537171077/0cb29e8067'} supportLink={''} />
                                    }
                                    <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={isLoading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

export default Rss
